/**
 * 首页
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL
// 预约
export interface NoticeInfo {
  appointmentStatus: string // 0：没有预约单 1：预约开始2：预约未开始
  appointmentSign?: string // 0：没有预约单 1：预约开始2：预约未开始
}
export async function getVideoAppointment(params?: Record<string, any>): Promise<NoticeInfo> {
  const response = await fetch(baseUrl + '/repair/appointment/queryIndexVideoAppointmentList', {
    method: 'GET',
  })
  const result: ApiResponse<NoticeInfo> = await response.json()
  return result.result
}
export async function lickRecordApi(module: string): Promise<any> {
  const response = await fetch(baseUrl + '/sys/common/click?module=' + module, {
    method: 'GET',
  })
  const result: ApiResponse<any> = await response.json()
  return result.result
}
export async function getQueryUser(finalEncryptedParams: string): Promise<any> {
  const response = await fetch(baseUrl + '/repair/wechat/queryUser?sessionKey=' + finalEncryptedParams, {
    method: 'GET',
  })
  const result: ApiResponse<any> = await response.json()
  return result.result
}
export async function queryAgreement(finalEncryptedParams: string): Promise<string> {
  const response = await fetch(baseUrl + '/repair/wechat/queryAgreement?sessionKey=' + finalEncryptedParams, {
    method: 'GET',
  })
  const result: ApiResponse<string> = await response.json()
  return result.result
}
